<template>
    <div class="page zhuanqu" ref="scroller">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            class="list"
            ref="list"
        >
            <div class="item" v-for="item in list" :key="item.id">
                <div class="top" @click="goCourseDetail(item)">
                    <div class="left">
                        <div
                            class="imgBox"
                            :style="{
                                background:
                                    'url(' +
                                    item.adImg +
                                    ') no-repeat center/100% 100%',
                            }"
                        ></div>
                        <div class="updateTime">{{ item.updateTime }} 更新</div>
                        <!-- <div class="activity-time-notice-box">
                            <img
                                class="activity-time-notice"
                                src="~@/assets/activity-time-notice.png"
                                alt=""
                            />
                            <span class="notice">限时7天</span>
                        </div> -->
                    </div>
                    <div class="right">
                        <div>
                            <div class="sub-title">{{ item.title }}</div>
                            <div class="desc" v-html="item.brief"></div>
                            <div
                                class="leturerBox"
                                v-if="item.trainerName.length > 0"
                            >
                                <img
                                    class="leturer-logo"
                                    src="~@/assets/leturer-logo.png"
                                    alt=""
                                />
                                <span class="leturers">
                                    <span
                                        v-for="trainer in item.trainerName"
                                        :key="trainer"
                                    >
                                        {{ trainer }}
                                    </span>
                                </span>
                            </div>
                            <div class="fenshiBox" v-if="item.studentNum">
                                <img
                                    class="fenshi-logo"
                                    src="~@/assets/fenshi-logo.png"
                                    alt=""
                                />
                                <span class="num">{{ item.studentNum }}</span>
                            </div>
                            <div
                                class="markBox"
                                v-if="item.tagsName.length > 0"
                            >
                                <span
                                    class="mark"
                                    v-for="tag in item.tagsName"
                                    :key="tag"
                                >
                                    {{ tag }}
                                </span>
                            </div>
                        </div>
                        <div v-if="item.expireTime">
                            到期时间：{{ item.expireTime }}
                        </div>
                    </div>
                </div>
                <div class="bottom" v-if="item.prize">
                    <div class="left">购买本产品,{{ item.prize.message }}</div>
                    <div class="right">
                        <button
                            class="getPrize"
                            @click.prevent="goGetPrize(item.prize.giftId)"
                        >
                            去领取
                        </button>
                    </div>
                </div>
            </div>
        </van-list>
        <div class="no-content-box" v-if="showNoContent">
            <img class="no-content" src="~@/assets/no-content.png" alt="" />
            <div>请先购买课程再来学习哦</div>
        </div>
    </div>
</template>

<script>
    import courseService from "../../service/course.service";
    import scrollerMixin from "../../scroller.mixin";
    export default {
        name: "course-list",
        mixins: [scrollerMixin],
        data() {
            return {
                loading: true,
                finished: false,
                list: [],
                page: 0,
                row: 10,
                showNoContent: false,
                error: false,
            };
        },
        mounted() {
            if (this.loading) {
                this.onLoad();
            }
        },
        methods: {
            goGetPrize(id) {
                this.$router.push({ path: "/get-prize-method", query: { id } });
            },
            onLoad() {
                courseService
                    .getStudyList({ page: this.page, row: this.row })
                    .then((res) => {
                        this.page++;
                        this.list.push(...res.data.list);
                        if (this.list.length <= 0) {
                            this.showNoContent = true;
                            this.loading = false;
                            this.finished = true;
                        }
                        this.loading = false;
                        if (this.list.length >= res.data.count) {
                            this.finished = true;
                        }
                    })
                    .catch(() => {
                        this.error = true;
                    });
            },
            goCourseDetail(obj) {
                let { id, type, inLink } = obj;
                console.log(obj);
                if (inLink) {
                    this.$router.push(inLink);
                } else {
                    this.$router.push({ path: `/course-detail/${id}/${type}` });
                }
            },
        },
    };
</script>
<style lang="scss" scoped src="./course-list.scss"></style>
